import script from "./QueryFromFile.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryFromFile.vue?vue&type=script&setup=true&lang=js"

import "./QueryFromFile.vue?vue&type=style&index=0&id=41a2e28f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41a2e28f"]])

export default __exports__